/* IKARAO Support search: local, dependency-free retrieval. No customer queries leave the browser. */
(function (global) {
  'use strict';

  const STOP = new Set(('a an the i me my mine we our you your yours he she it its they their this that these those is am are was were be been being have has had do does did can could would should will shall may might must to of for from with as at by in into on onto and or but if then than so because while when where why how what which who whom please really just very also still now already anymore again only any some all both each same much many about after before during through without using use used need needs want wants get getting got make let tell explain know trying try help issue issues problem problems trouble work working works happen happens happened stop stops stopped start starts begin sometimes suddenly seem seems ikarao machine device product products says say showing show shown').split(' '));
  // Negative words intentionally survive normalization; they help distinguish a fault from setup.
  const NEGATIVE = new Set(['not', 'never', 'without']);
  STOP.delete('without');
  const ALIASES = Object.create(null);
  const groups = {
    not: 'no none cannot unable impossible doesnt dont wont cant isnt arent didnt wasnt ne pas plus aucun aucune sans',
    microphone: 'mic mics microphones micro micros microfone microfones microphone microfono microfonos microphon',
    sound: 'audio voice voices volume audible hear hearing heard son sons entendre entends entend voix sonido',
    charge: 'charging charged charges charger chargers recharge recharging recharged recharges chargement charger recharge recharger chargeur chargeurs',
    power: 'powered powering startup demarrage allumer allume allumage encender',
    battery: 'batteries batterie batteria',
    connect: 'connected connecting connection connections pair paired pairing pairs sync syncing synchronize synchronise synchronization reconnect reconnecting link linked appairer appairage jumeler jumelage connecter connecte connexion branchement brancher',
    disconnect: 'disconnected disconnecting deconnexion deconnecte',
    bluetooth: 'bluetooth bt',
    wifi: 'wifi wlan',
    tv: 'television televisions televison televiseur tele televisor',
    phone: 'phones smartphone smartphones mobile mobiles telephone telephones iphone androidphone',
    song: 'songs track tracks chanson chansons morceau morceaux',
    music: 'musical musique musica',
    preview: 'previews previewing sample samples snippet snippets extrait extraits apercu apercus',
    account: 'accounts compte comptes cuenta',
    login: 'signin logon logged login connexioncompte connectercompte',
    register: 'registered registering registration signup inscription inscrire creer create creating creation',
    password: 'passwords passcode motdepasse',
    activate: 'activation activated activating activer active activation',
    membership: 'subscription subscriptions abonnement abonnements member members premium',
    offer: 'offers included inclusion promotion promotions free gratuit gratuite cadeau',
    download: 'downloads downloading downloaded telecharger telechargement',
    update: 'updates updating updated upgrade upgrades firmware miseajour',
    app: 'apps application applications appli applis',
    manual: 'manuals handbook handbooks instruction instructions documentation manuel manuels notice notices',
    guide: 'guides tutorial tutorials tutoriel tutoriels',
    video: 'videos recording recordings',
    order: 'orders ordered ordering commande commandes achat achats',
    delivery: 'deliver delivered delivering shipping shipment shipments parcel parcels livraison livrer expedition colis',
    track: 'tracking tracked suivre suivi',
    return: 'returns returning returned refund refunds refunded remboursement rembourse rembourser retour retours retourner',
    exchange: 'exchanges replacement replacements replace replaced replacing echange echanger remplacement remplacer',
    warranty: 'warranties guarantee guarantees garantie garanties',
    customs: 'duty duties tax taxes tariff tariffs douane douanes taxe taxes',
    cost: 'costs price prices fee fees pay payable paid paying tarif tarifs cout couts frais payer',
    address: 'addresses adresse adresses',
    damage: 'damaged broken breakage defect defective casse cassee abime endommage',
    missing: 'lost lose loss manque manquant manquante perdu',
    accessory: 'accessories accessoire accessoires',
    compatible: 'compatibility supported supporte compatible compatibles',
    screen: 'screens display displays ecran ecrans',
    setup: 'setups installation installer install initial premier premiere',
    indicator: 'indicators light lights led leds voyant voyants lumiere',
    red: 'rouge rouges',
    blue: 'bleu bleue',
    yellow: 'jaune',
    flashing: 'flash flashes blinking blink blinks clignote clignotant',
    email: 'emails mail mails courriel courriels',
    contact: 'contacting contacter assistance service customer support',
    serial: 'sn serie',
    model: 'models modele modeles',
    outdoor: 'outdoors outside exterieur',
    waterproof: 'waterproofing waterresistant etanche',
    karafun: 'karafun',
    usb: 'usb',
    hdmi: 'hdmi',
    hdmiarc: 'hdmiarc',
    aux: 'aux auxiliary',
    spotify: 'spotify',
    youtube: 'youtube',
    netflix: 'netflix'
  };
  Object.keys(groups).forEach(key => {
    ALIASES[key] = key;
    groups[key].split(' ').forEach(term => { ALIASES[term] = key; });
  });
  const FRENCH_STOP = 'je j mon ma mes le la les un une des du de d l c ce cet cette ces est sont et ou mais au aux en pour par sur sous avec comment pourquoi quel quelle quels quelles que qui quand faire fait fonctionne fonctionner marche marcheplus il elle nous vous vos notre a ai avez suis pouvez peut peux dois besoin souhaite merci tres bien toujours neplus';
  FRENCH_STOP.split(' ').forEach(term => STOP.add(term));
  'anything something everything unit units longer somebody someone'.split(' ').forEach(term => STOP.add(term));
  const ENTITIES = new Set(['karafun', 'spotify', 'youtube', 'netflix', 'applemusic', 'hdmi', 'usb', 'tf', 'aux', 'wifi', 'bluetooth']);
  const MODELS = /^(?:x[12]|s[123]|k1|micbox)$/;
  const MODEL_KEYS = {x1:'break-x1', x2:'break-x2', s1:'shell-s1', s2:'shell-s2', s3:'shell-s3', k1:'sparkle-k1', micbox:'micbox-pro'};
  const SCREEN_FEATURES = new Set(['karafun', 'wifi', 'app', 'update', 'screen', 'netflix', 'youtube', 'spotify', 'applemusic']);

  function normalize(value) {
    return String(value == null ? '' : value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/<[^>]*>/g, ' ').replace(/&(?:nbsp|amp|quot|apos);/g, ' ')
      .replace(/[’‘`]/g, "'")
      .replace(/\b(?:won't|can't|cannot|don't|doesn't|didn't|isn't|aren't|wasn't|weren't|couldn't|wouldn't|shouldn't)\b/g, ' not ')
      .replace(/\b(?:wi[ -]?fi)\b/g, ' wifi ')
      .replace(/\b(?:kara[ -]?fun)\b/g, ' karafun ')
      .replace(/\bapple\s+music\b/g, ' applemusic ')
      .replace(/\b(?:sign[ -]?in|log[ -]?in|logged\s+in)\b/g, ' login ')
      .replace(/\b(?:sign[ -]?up)\b/g, ' register ')
      .replace(/\b(?:backing\s+tracks?)\b/g, ' music ')
      .replace(/\b(?:no\s+vocals?)\b/g, ' not microphone sound ')
      .replace(/\b(?:produce|producing|outputting)\s+(?:any\s+)?(?:sound|audio)\b/g, ' sound ')
      .replace(/\b(?:where\s+(?:is|are)|ou\s+est)\b(?=[^.!?]*\b(?:order|parcel|package|shipment|delivery|commande|colis)\b)/g, ' track ')
      .replace(/\b(?:silent|silence|muted)\b/g, ' not sound ')
      .replace(/\b(?:turn(?:s|ed|ing)?|switch(?:es|ed|ing)?)\s+on\b/g, ' power ')
      .replace(/\b(?:turn(?:s|ed|ing)?|switch(?:es|ed|ing)?|shut(?:s|ting)?)\s+off\b/g, ' shutdown ')
      .replace(/\bshut(?:s|ting)?\s+down\b/g, ' shutdown ')
      .replace(/\b(?:30|thirty)\s*(?:sec(?:ond)?s?|s)\b/g, ' preview ')
      .replace(/\b(?:mot\s+de\s+passe)\b/g, ' password ')
      .replace(/\bmise\s+a\s+jour\b/g, ' update ')
      .replace(/\b(?:break|shell|sparkle)[ -]*([xsk])[ -]*([123])\b/g, ' $1$2 ')
      .replace(/\b([xsk])[ -]+([123])\b/g, ' $1$2 ')
      .replace(/\bmicbox(?:[ -]+pro)?\b/g, ' micbox ')
      .replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function canonical(word) {
    if (ALIASES[word]) return ALIASES[word];
    if (word.length > 4 && /ies$/.test(word)) return word.slice(0, -3) + 'y';
    if (word.length > 4 && /s$/.test(word) && !/(ss|us|is)$/.test(word)) return word.slice(0, -1);
    return word;
  }
  function tokens(value) {
    let text = normalize(Array.isArray(value) ? value.join(' ') : value);
    if (/\b(?:shipping|delivery|customs|import|order|checkout|tax|duties)\b/.test(text) && !/\b(?:battery|adapter|microphone)\b/.test(text)) text = text.replace(/\bcharges?\b/g, ' cost ');
    return text.split(' ')
      .filter(word => word && !STOP.has(word)).map(canonical)
      .filter(word => !STOP.has(word) && (word.length > 1 || MODELS.test(word)));
  }
  function modelList(value) {
    return Array.from(new Set(tokens(value).filter(word => MODELS.test(word))));
  }
  function detectModel(value) {
    const found = modelList(value);
    return found.length === 1 ? MODEL_KEYS[found[0]] : null;
  }
  function focusFault(value) {
    const clauses = String(value || '').split(/\b(?:but|however|mais|cependant)\b/i);
    if (clauses.length < 2) return value;
    const hasFault = clause => /\b(?:not|no|never|silent|silence|missing|broken|failed|error|dead|pas|aucun|aucune)\b/.test(normalize(clause));
    const last = clauses[clauses.length - 1];
    if (hasFault(last)) return last;
    const earlierFault = clauses.slice(0, -1).find(hasFault);
    return earlierFault || value;
  }
  function editDistance(a, b, limit) {
    if (Math.abs(a.length - b.length) > limit) return limit + 1;
    let prev = Array.from({length: b.length + 1}, (_, i) => i);
    for (let i = 1; i <= a.length; i++) {
      const next = [i];
      for (let j = 1; j <= b.length; j++) {
        next[j] = Math.min(next[j - 1] + 1, prev[j] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      if (Math.min.apply(null, next) > limit) return limit + 1;
      prev = next;
    }
    return prev[b.length];
  }

  function create(entries) {
    const vocabulary = new Set();
    const primaryVocabulary = new Set();
    const frequency = new Map();
    const documents = (Array.isArray(entries) ? entries : []).filter(Boolean).map((entry, index) => {
      const fields = [tokens(focusFault(entry.name)), tokens(entry.keywords), tokens(entry.category), tokens(entry.body)];
      fields[0].concat(fields[1]).forEach(term => primaryVocabulary.add(term));
      const set = new Set(fields.flat());
      set.forEach(term => { vocabulary.add(term); frequency.set(term, (frequency.get(term) || 0) + 1); });
      const declared = Array.isArray(entry.models) ? entry.models : entry.models ? [entry.models] : [];
      const models = modelList(declared.length ? declared.join(' ') : entry.name);
      return {entry, index, fields, set, models};
    });
    const idf = term => 1 + Math.log(1 + (documents.length + 1) / ((frequency.get(term) || 0) + 1));
    const typoVocabulary = Array.from(primaryVocabulary).filter(term => /^[a-z]{4,}$/.test(term) && !NEGATIVE.has(term));
    function correct(term) {
      if (vocabulary.has(term) || MODELS.test(term) || /\d/.test(term) || term.length < 4 || NEGATIVE.has(term) || ENTITIES.has(term)) return term;
      const limit = term.length >= 8 ? 2 : 1;
      let best = limit + 1, candidates = [];
      typoVocabulary.forEach(candidate => {
        // Same first letter avoids turning unrelated short terms into a brand or product.
        if (term[0] !== candidate[0]) return;
        const distance = editDistance(term, candidate, limit);
        if (distance < best) { best = distance; candidates = [candidate]; }
        else if (distance === best) candidates.push(candidate);
      });
      return best <= limit && candidates.length === 1 ? candidates[0] : term;
    }
    function search(query, options) {
      const original = String(query == null ? '' : query).trim().slice(0, 500);
      // The clause after "but" usually states the outstanding fault, while the first
      // clause describes what already works. This avoids treating both as broken.
      const focusedQuery = focusFault(original);
      const raw = Array.from(new Set(tokens(focusedQuery)));
      const correctedTerms = [];
      const terms = Array.from(new Set(raw.map(term => {
        const corrected = correct(term);
        if (corrected !== term) correctedTerms.push({from: term, to: corrected});
        return corrected;
      })));
      const queryModels = modelList(original);
      const requestedModels = queryModels.length ? queryModels : modelList((options && options.model) || '');
      const model = requestedModels.length === 1 ? MODEL_KEYS[requestedModels[0]] : null;
      const meaningful = terms.filter(term => !MODELS.test(term) && !NEGATIVE.has(term));
      const negative = terms.some(term => NEGATIVE.has(term));
      const requiredEntities = meaningful.filter(term => ENTITIES.has(term));
      // Unknown app names/subjects must not disappear behind generic words such as "not working".
      const unknown = meaningful.filter(term => !vocabulary.has(term));
      const totalWeight = meaningful.reduce((sum, term) => sum + idf(term), 0);
      if (/\b[xsk][ -]?\d+\b/.test(normalize(original).replace(/\b(?:x[12]|s[123]|k1)\b/g, '')) || (!meaningful.length && !requestedModels.length) || (unknown.length && unknown.length >= Math.max(1, meaningful.length / 2))) {
        return {query: original, hits: [], correctedTerms, model};
      }
      const hits = [];
      documents.forEach(doc => {
        if (requestedModels.length && doc.models.length && !requestedModels.some(model => doc.models.includes(model))) return;
        if (model === 'micbox-pro' && meaningful.some(term => SCREEN_FEATURES.has(term)) && !doc.models.includes('micbox')) return;
        if (requiredEntities.some(term => !doc.set.has(term))) return;
        const matched = meaningful.filter(term => doc.set.has(term));
        if (matched.length && matched.every(term => !doc.fields[0].includes(term) && !doc.fields[1].includes(term) && !doc.fields[3].includes(term)) && !requiredEntities.length) return;
        const coveredWeight = matched.reduce((sum, term) => sum + idf(term), 0);
        const coverage = totalWeight ? coveredWeight / totalWeight : 1;
        if (meaningful.length && (!matched.length || coverage < (meaningful.length <= 2 ? 0.62 : 0.58))) return;
        if (!meaningful.length && !requestedModels.some(model => doc.set.has(model))) return;
        let score = 0;
        matched.forEach(term => {
          const fieldWeight = [7, 4, 1.5, 1];
          doc.fields.forEach((field, fieldIndex) => {
            const count = field.filter(word => word === term).length;
            if (!count) return;
            const norm = 0.75 + 0.25 * Math.max(1, field.length / [10, 25, 5, 100][fieldIndex]);
            score += idf(term) * fieldWeight[fieldIndex] * (count * 1.8 / (count + 0.8 * norm));
          });
        });
        score *= 0.45 + coverage * coverage * 0.55;
        const titleMatched = matched.filter(term => doc.fields[0].includes(term)).length;
        if (matched.length && titleMatched === meaningful.length) score *= 1.3;
        if (negative && doc.fields[0].some(term => term === 'not' || term === 'never')) score *= 1.6;
        if (negative && doc.fields[0].includes('without') && !terms.includes('without')) score *= 0.4;
        if (negative && doc.fields[0].includes('external') && !meaningful.includes('external')) score *= 0.5;
        const subject = meaningful.includes('microphone') ? 'microphone' : meaningful.includes('music') ? 'music' : meaningful.includes('phone') ? 'phone' : '';
        if (subject && doc.fields[0].includes(subject)) score *= 1.2;
        if (subject === 'microphone' && doc.fields[0].includes('phone') && !doc.fields[0].includes('microphone')) score *= 0.3;
        if (subject === 'phone' && doc.fields[0].includes('microphone') && !doc.fields[0].includes('phone')) score *= 0.3;
        if (subject === 'music' && doc.fields[0].includes('microphone') && !doc.fields[0].includes('music')) score *= 0.4;
        if (requestedModels.some(model => doc.models.includes(model))) score += 7;
        else if (requestedModels.some(model => doc.set.has(model))) score += 2;
        const queryPhrase = meaningful.join(' ');
        if (queryPhrase && doc.fields[0].join(' ').includes(queryPhrase)) score += 4;
        hits.push({...doc.entry, score: Math.round(score * 1000) / 1000, _searchIndex: doc.index});
      });
      hits.sort((a, b) => b.score - a.score || a._searchIndex - b._searchIndex);
      hits.forEach(hit => { delete hit._searchIndex; });
      return {query: original, hits, correctedTerms, model};
    }
    return {search};
  }
  global.IKARAO_SUPPORT_SEARCH = Object.freeze({create, normalize, detectModel, version: '1.0.0'});
})(typeof window !== 'undefined' ? window : globalThis);
